module.exports = __webpack_public_path__ + "static/icon-accessories-0a2b9bacf623502425b50262688c3706.svg";